<template>
  <div class="favorite-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.favorite') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.favorite') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="favorite"/>
      </div>
      <div class="page-right step-content">
        <list-view
          @scrollOnBottom="handleOnScrollBottom"
          :showLoading="listLoading"
        >
          <div slot="header-center">{{ $t('favorite.product_info') }}</div>
          <div slot="list-container">
            <div class="list-item" v-for="(item,index) in list" :key="index+'_product'">
              <div class="item-img">
                <div class="product-img" :style="{ backgroundImage: `url(${item.photo})` }"></div>
              </div>
              <div class="item-content">
                <p class="p-number">{{ $t('favorite.product_no') }}: {{ item.no }}</p>
                <p class="p-name"><span>{{ $t('favorite.product_name') }}:</span> {{ item.name }}</p>
                <!-- <p class="p-brand">品牌: 白</p> -->
                <p class="p-price"><span>{{ $t('favorite.price') }}:</span> ${{ item.price }}</p>
              </div>
              <div class="item-btns hide-on-pad-flex">
                <div class="btn btn-orange" @click="addCart(item.id)">{{ $t('favorite.add_cart') }}</div>
                <div class="btn btn-grey" @click="handleRemoveItem(item.id)">{{ $t('favorite.remove') }}</div>
              </div>
              <div class="item-btns show-on-pad-flex">
                <div class="btn btn-light-orange add-btn" @click="addCart(item.id)">{{ $t('favorite.add_cart') }}</div>
                <div class="btn btn-light-orange delete-btn" @click="handleRemoveItem(item.id)">{{ $t('favorite.remove') }}</div>
              </div>
              <div class="label-group choose-input">
                <!-- <input type="checkbox" :id="`choose-item-${item.id}`" :value="item.id"><label @click.capture="handleChooseItem(item.id)" :for="`choose-item-${item.id}`" class="square"></label> -->
              </div>
            </div>
          </div>
        </list-view>
        <!-- <div class="btn btn-orange all-add">整批加入购物车</div> -->
      </div>
    </div>
    <AddCartDrawer ref="drawer"/>
  </div>
</template>

<script>
import UserSideMenu from '../../components/UserSideMenu'
import ListView from '../../components/ListView'
import { cloudConfirm } from '../../utils/tools'
import { getMemberLike, addMemberLike } from '../../api'
import { mapActions } from 'vuex'
import AddCartDrawer from '@/components/AddCardDrawer/index.vue'

  export default {
    name: 'favorite',
    data() {
      return {
        list: [],
        chooseItem: [],
        count: 10, 
        pages: 0,
        gettingList: false,
        listLoading: true
      }
    },
    components: {
      UserSideMenu,ListView,AddCartDrawer
    },
    async created() {
      this.getList();
    },
    methods: {
      ...mapActions(['handleMemberLike']),
      async getList() {
        // 如果已经取完了就不要再读取了
        if(!this.listLoading) return;
        // 如果在取资料中就不要再来了
        if(this.gettingList) return;
        this.gettingList = true;
        this.pages = this.pages + 1;
        const { product } = await getMemberLike({ count:this.count,pages:this.pages });
        console.log('product',product);
        if(product.length>0) {
          const newList = this.list.concat(product);
          this.list = newList;
        }else{
          this.listLoading = false;
        }
        this.gettingList = false
      },
      handleChooseItem(id) {
        console.log('id',id);
        let newChooseItem = this.chooseItem;
        if(this.chooseItem.includes(id)) {
          console.log('in');
          newChooseItem = this.chooseItem.filter(item => item!=id);
        }else{
          console.log('out');
          newChooseItem.push(id);
        }
        this.chooseItem = newChooseItem;
      },
      async handleRemoveItem(id) {
        try {
          await cloudConfirm();
          // await addMemberLike({ product_no: no});
          await this.handleMemberLike(id);
          const newList = this.list.filter(item => item.no!=no);
          this.list = newList;
          this.$message({
            message: this.$t('alert_message.remove_success'),
            type: 'success'
          });
        } catch (error) {
          console.log('error',error);
        }
      },
      handleOnScrollBottom() {
        this.getList();
      },
      addCart(pid) {
        this.$refs.drawer.handleOpenAddCartDrawer(pid);
      }
    }
  }
</script>

<style lang="less" scoped>
.favorite-page {
  .list-item {
    display: flex;
    border-bottom: 1px solid #E6E6E6;
    padding: 20px 0;
    .item-img {
      width: 120px;
      .product-img {
        width: 100%;
        padding-top: 125%;
        background: #F0F0F0;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .item-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 5px 20px;
    }
    .item-btns {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .btn {
        width: 125px;
        margin-bottom: 16px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }
  .all-add {
    width: 160px;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .delete-btn,.choose-input {
    display: none;
  }
  @media (max-width: 992px) {
    background-color: #F7F8FA;  
    .page-container {
      padding-top: 0;
    }
    .list-item {
      background: white;
      padding: 20px;
      border-radius: 6px;
      box-shadow: 2px 4px 6px 2px rgba(0,0,0,.1);
      margin-bottom: 16px;
      border-bottom: unset;
      position: relative;
      .item-img {
        width: 90px;
        .product-img {
          padding-top: 100%;
          border-radius: 5px;
        }
      }
      .item-content {
        padding: 5px 10px;
      }
      .p-number {
        font-size: 12px;
      }
      .p-name {
        font-size: 1.4rem;
        margin-top: 6px;
        margin-bottom: 14px;
        font-weight: 400;
        span {
          display: none;
        }
      }
      .p-brand {
        display: none;
      }
      .p-price {
        color: #FF5214;
        font-weight: bold;
        font-size: 1.2rem;
        span {
          display: none;
        }
      }
      .item-btns {
        flex-direction: row;
        position: absolute;
        bottom: 22px;
        right: 20px;
        .btn {
          margin-bottom: 0;
          width: auto;
          padding: 4px 4px;
          border-radius: 5px;
          margin-right: 5px;
          &:nth-last-child(1) {
            margin-right: 0;
          }
        }
      }
      .label-group {
        position: absolute;
        top: 20px;
        right: -7px;
        label::before {
          border-color: #E6E6E6;
        }
      }
    }
    .delete-btn,.choose-input {
      display: flex;
    }
  }

}
</style>